export const COMMIT_ID =
  import.meta.env.VITE_COMMIT_ID?.slice(0, 8) || 'unknown';

export const APP_VERSION = import.meta.env.VITE_VERSION;
